import React from "react";
import './Photo.css'

const Photo = () => {
    return ( 
        
        <div className="Photo">
            <img src="/wantedholed.png" alt="wanted"/>
        </div>

    );
}
 
export default Photo;